
import { useState } from 'react';

import Modal from "../../../views/utils/Modal";

import { LabelAdder } from '../../components/primitive/Label';
import { BoxAdder } from '../../components/primitive/Box';
import { InputAdder } from '../../components/primitive/Input';
import { ButtonAdder } from '../../components/primitive/Button';
import { RadioAdder } from '../../components/primitive/Radio';
import { CheckAdder } from '../../components/primitive/Check';
import { ListAdder } from '../../components/primitive/List';
import { DropAdder } from '../../components/primitive/Drop';
import { ImageAdder } from '../../components/primitive/Image';

import { SignatureAdder } from '../../components/intermediate/Signature';
import { InputTableAdder } from '../../components/intermediate/InputTable';
import { SnapshotAdder } from '../../components/intermediate/Snapshot';

export default function AddElement ({ comps, setComps, setView, page, setSelectedEl }) {

    const  [ tab, setTab ] = useState('primitive');

    const component_list = {
        primitive: [
            <BoxAdder comps={comps} setComps={setComps} setView={setView} page={page} setSelectedEl={setSelectedEl} />,
            <LabelAdder comps={comps} setComps={setComps} setView={setView} page={page} setSelectedEl={setSelectedEl} />,
            <InputAdder comps={comps} setComps={setComps} setView={setView} page={page} setSelectedEl={setSelectedEl} />,
            <ButtonAdder comps={comps} setComps={setComps} setView={setView} page={page} setSelectedEl={setSelectedEl} />,
            <RadioAdder comps={comps} setComps={setComps} setView={setView} page={page} setSelectedEl={setSelectedEl} />,
            <CheckAdder comps={comps} setComps={setComps} setView={setView} page={page} setSelectedEl={setSelectedEl} />,
            <ListAdder comps={comps} setComps={setComps} setView={setView} page={page} setSelectedEl={setSelectedEl} />,
            <DropAdder comps={comps} setComps={setComps} setView={setView} page={page} setSelectedEl={setSelectedEl} />,
            <ImageAdder comps={comps} setComps={setComps} setView={setView} page={page} setSelectedEl={setSelectedEl} />
        ],
        intermediate: [
            <SignatureAdder comps={comps} setComps={setComps} setView={setView} page={page} setSelectedEl={setSelectedEl} />,
            <InputTableAdder comps={comps} setComps={setComps} setView={setView} page={page} setSelectedEl={setSelectedEl} />,
            <SnapshotAdder comps={comps} setComps={setComps} setView={setView} page={page} setSelectedEl={setSelectedEl} />
        ],
        advanced: [

        ]
    };

    let component_list_render = component_list[tab];

    const tabStyling = {
        display: 'inline-block',
        marginLeft: '1vmax',
        marginRight: '1vmax',
        transition: 'font-weight 0.1s, border-bottom 0.1s',
        paddingBottom: '0.05vmax'
    };

    return (<>
        <Modal width={30} height={40}>
            <h1 style={{
                color: '#FAF3DD',
                fontWeight: '300',
                margin: '0',
                padding: '1vmax 0',
                fontSize: '1.75vmax',
                borderBottom: '1px #FAF3DD solid',
                display: 'block'
            }}>Add Element</h1>
            <div style={{
                marginBottom: '0.5vmax'
            }}>
                <p className='panel-label pointy' style={{
                    ...tabStyling,
                    fontWeight: tab === 'primitive' ? '700' : '300',
                    borderBottom: tab === 'primitive' ? '1px #FAF3DD solid' : ''
                }} onClick={() => {
                    setTab('primitive');
                }}>Primitive</p>
                <p className='panel-label pointy' style={{
                    ...tabStyling,
                    fontWeight: tab === 'intermediate' ? '700' : '300',
                    borderBottom: tab === 'intermediate' ? '1px #FAF3DD solid' : ''
                }} onClick={() => {
                    setTab('intermediate');
                }}>Intermediate</p>
                <p className='panel-label pointy' style={{
                    ...tabStyling,
                    fontWeight: tab === 'advanced' ? '700' : '300',
                    borderBottom: tab === 'advanced' ? '1px #FAF3DD solid' : ''
                }} onClick={() => {
                    setTab('advanced');
                }}>Advanced</p>
            </div>
            <div style={{
                overflow: 'scroll',
                height: '47.5%'
            }}>
                {component_list_render}
            </div>
            <div style={{
                position: 'absolute',
                bottom: '0',
                width: '100%',
                backgroundColor: '#000000'
            }}>
                <a href='' className='panel-button' style={{
                    marginBottom: '1vmax'
                }} onClick={(e) => {
                    e.preventDefault();
                    setView('');
                }}>Cancel</a>
            </div>
        </Modal>
    </>);

}